import React, { useState, useEffect, useCallback } from 'react';
import { View, ScrollView, Text, TouchableOpacity, StyleSheet } from 'react-native';
import '../components/CommonButton.css';
import CategoryListManager from '../components/CategoryListManager';
import GeneralSettingsCard from '../components/GeneralSettingsCard';
import TeamBuilderMixed from '../components/TeamBuilderMixed';
import { generateMixedMatches, mergeMixedMatches } from '../utils/matchGeneratorMixed';
import { useNavigate } from 'react-router-dom';
import {
  UsersIcon,
  FencingSwordsIcon,
  SwapIcon,
  ChartBarIcon
} from '../components/FencingIcons';

// defaultCategories rimosso (inutilizzato)


const MixedCompetitionConfig = () => {
  const navigate = useNavigate();
  // Stato categorie partecipanti
  const [categories, setCategories] = useState([]);
  // Stato numero squadre
  const [numTeams, setNumTeams] = useState(2);
  // Stato stoccate per assalto (globale)
  const [stoccate, setStoccate] = useState(5);
  // Stato alternanza categorie (true = zig-zag, false = sequenziale)
  const [alternateCategories, setAlternateCategories] = useState(true);
  // Stato squadre
  const [teams, setTeams] = useState([
    { name: '', members: [] },
    { name: '', members: [] }
  ]);
  // setMatches rimosso (inutilizzato)
  // Flag per indicare che il caricamento è completo
  const [caricamentoCompleto, setCaricamentoCompleto] = useState(false);

  // CARICAMENTO DATI AL PRIMO MOUNT
  useEffect(() => {
    console.log("CARICAMENTO INIZIALE CONFIGURAZIONE MISTA");
    try {
      // Determina il tipo di competizione
      const competitionType = localStorage.getItem('competitionType');
      console.log("Tipo competizione rilevato:", competitionType);

      // Se non è una competizione mista, usa i default
      if (competitionType !== 'mixed') {
        console.log("Non è una competizione mista, uso valori default");
        setCaricamentoCompleto(true);
        return;
      }

      // Carica config
      const savedConfig = JSON.parse(localStorage.getItem('mixed_config'));
      console.log("Config caricata:", savedConfig);
      if (savedConfig) {
        // Carica il numero di squadre
        if (savedConfig.numTeams && savedConfig.numTeams !== numTeams) {
          setNumTeams(savedConfig.numTeams);
        }

        // Carica le stoccate
        if (savedConfig.stoccate && savedConfig.stoccate !== stoccate) {
          setStoccate(savedConfig.stoccate);
        }

        // Carica alternanza categorie
        if (typeof savedConfig.alternateCategories === 'boolean') {
          setAlternateCategories(savedConfig.alternateCategories);
        }

        // Carica le categorie
        if (Array.isArray(savedConfig.categories)) {
          setCategories([...savedConfig.categories]);
        }
      }

      // Carica teams
      const savedTeams = JSON.parse(localStorage.getItem('teams'));
      console.log("Teams caricati:", savedTeams);
      if (Array.isArray(savedTeams) && savedTeams.length > 0) {
        // Verifica che le squadre abbiano tutte le informazioni necessarie
        const validTeams = savedTeams.map(team => {
          // Gestione corretta dei membri con deep clone
          let members = [];
          if (Array.isArray(team.members)) {
            members = team.members.map(m => ({
              ...m,
              name: m.name || '',
              category: m.category || '',
              id: m.id || Date.now() + Math.random()
            }));
          }

          // Ritorna team completo
          return {
            ...team,
            name: team.name || '',
            members: members
          };
        });

        console.log("Teams validati con membri completi:", validTeams);
        setTeams(validTeams);
      }

      // Caricamento matches rimosso (inutilizzato)
    } catch (e) {
      console.error("Errore caricamento config mista:", e);
    } finally {
      setCaricamentoCompleto(true);
    }
  }, [numTeams, stoccate, categories, alternateCategories, teams]);




  // Funzione per generare match misti (unificata)
  const generateMatchesWithSpecialCase = useCallback(() => {
    console.log("Generazione matches unificata", { teams, categories, stoccate });
    // Verifica che ci siano squadre e categorie valide
    if (!teams || teams.length === 0 || !categories || categories.length === 0) {
      console.log("Nessuna squadra o categoria disponibile");
      return [];
    }
    // Verifica che le squadre abbiano nomi diversi
    const validTeams = teams.filter(t => t && t.name && t.name.trim() !== '');
    if (validTeams.length < 2) {
      console.log("Non ci sono almeno due squadre valide");
      return [];
    }
    // Usa sempre la funzione unificata con il flag alternanza
    const rawMatches = generateMixedMatches({ teams, categories, stoccate, alternate: alternateCategories });
    // Garantisce struttura completa dei match
    return rawMatches.map((m, idx) => {
      // Risolvi sempre il nome della squadra, anche se il campo è un indice
      let nomeA = '';
      let nomeB = '';
      // Se m.squadraA o m.teamA è un numero, cerca il nome nella lista teams
      if (typeof m.squadraA === 'number' && teams[m.squadraA]) nomeA = teams[m.squadraA].name;
      else if (typeof m.teamA === 'number' && teams[m.teamA]) nomeA = teams[m.teamA].name;
      else nomeA = m.squadraA || m.teamA || '';
      if (typeof m.squadraB === 'number' && teams[m.squadraB]) nomeB = teams[m.squadraB].name;
      else if (typeof m.teamB === 'number' && teams[m.teamB]) nomeB = teams[m.teamB].name;
      else nomeB = m.squadraB || m.teamB || '';
      return {
        squadraA: nomeA,
        squadraB: nomeB,
        categoria: m.categoria || (Array.isArray(m.categorie) ? m.categorie.join(',') : ''),
        stoccate: m.stoccate || stoccate,
        stoccateTotali: m.stoccateTotali || (m.assalti?.length || 0) * (m.stoccate || stoccate),
        assalti: m.assalti || [],
        punteggioA: typeof m.punteggioA === 'number' ? m.punteggioA : 0,
        punteggioB: typeof m.punteggioB === 'number' ? m.punteggioB : 0,
        stato: m.stato || 'da disputare',
        note: m.note || '',
        id: m.id || `${idx}_${nomeA}_${nomeB}_${m.categoria || (Array.isArray(m.categorie) ? m.categorie.join('_') : '')}`
      };
    });
  }, [teams, categories, stoccate, alternateCategories]);

  // Aggiornamento incontri rimosso (inutilizzato)

  // Aggiorna squadre se cambia il numero o le categorie
  useEffect(() => {
    // IMPORTANTE: Esegui questo effetto solo dopo il caricamento completo
    // per evitare di sovrascrivere i dati caricati da localStorage
    if (!caricamentoCompleto) return;

    console.log("Aggiornamento team per cambio numTeams o categories", { numTeams, categoriesLength: categories.length });

    setTeams(prevTeams => {
      // Aggiorna numero squadre
      let updated = [...prevTeams];
      while (updated.length < numTeams) {
        updated.push({ name: '', members: [] });
      }
      while (updated.length > numTeams) {
        updated.pop();
      }
      // Aggiorna membri per categoria
      updated = updated.map(team => {
        // Per ogni categoria, se mancano membri, aggiungi almeno uno
        const members = [...team.members];
        categories.forEach(cat => {
          if (members.filter(m => m.category === cat).length === 0) {
            members.push({ name: '', category: cat, id: Date.now() + Math.random() });
          }
        });
        // Rimuovi membri di categorie non più presenti
        const filtered = members.filter(m => categories.includes(m.category));
        return { ...team, members: filtered };
      });
      return updated;
    });
  }, [numTeams, categories, caricamentoCompleto]);

  return (
    <View style={styles.container}>
      <ScrollView style={styles.container}>
        <View style={{ alignItems: 'center', marginTop: 16, marginBottom: 2 }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <UsersIcon style={{ fontSize: 36, color: '#1976d2', marginRight: 12 }} />
            <Text style={{ fontSize: 32, fontWeight: 'bold', color: '#1976d2', margin: 0, textAlign: 'center', letterSpacing: 1, textShadow: '0px 2px 4px rgba(0,0,0,0.06)' }}>Squadre Miste</Text>
            <FencingSwordsIcon style={{ fontSize: 36, color: '#1976d2', marginLeft: 12 }} />
          </View>
          <View style={{ height: 4, backgroundColor: '#1976d2', width: 72, borderRadius: 2, alignSelf: 'center', marginTop: 2, marginBottom: 18, opacity: 0.2 }} />
        </View>
        {/* Card gestione categorie partecipanti */}
        <CategoryListManager categories={categories} setCategories={setCategories} />

        {/* Toggle per modalità alternanza categorie */}
        <View style={{
          backgroundColor: '#fff',
          borderRadius: 18,
          padding: 16,
          marginVertical: 12,
          borderWidth: 2,
          borderColor: '#1976d2',
          boxShadow: '0 4px 24px #0002',
        }}>
          <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#1976d2', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
            <SwapIcon /> Ordine Assalti
          </Text>
          <View style={{ flexDirection: 'row', gap: 12 }}>
            <TouchableOpacity
              style={{
                flex: 1,
                padding: 12,
                borderRadius: 12,
                backgroundColor: alternateCategories ? '#1976d2' : '#e3f2fd',
                borderWidth: 2,
                borderColor: '#1976d2',
                alignItems: 'center',
              }}
              onPress={() => setAlternateCategories(true)}
            >
              <SwapIcon style={{ fontSize: 24, marginBottom: 4, color: alternateCategories ? '#fff' : '#1976d2' }} />
              <Text style={{ fontWeight: 'bold', color: alternateCategories ? '#fff' : '#1976d2', fontSize: 14 }}>
                Zig-Zag
              </Text>
              <Text style={{ color: alternateCategories ? '#e3f2fd' : '#666', fontSize: 11, textAlign: 'center' }}>
                Alterna categorie
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                flex: 1,
                padding: 12,
                borderRadius: 12,
                backgroundColor: !alternateCategories ? '#1976d2' : '#e3f2fd',
                borderWidth: 2,
                borderColor: '#1976d2',
                alignItems: 'center',
              }}
              onPress={() => setAlternateCategories(false)}
            >
              <ChartBarIcon style={{ fontSize: 24, marginBottom: 4, color: !alternateCategories ? '#fff' : '#1976d2' }} />
              <Text style={{ fontWeight: 'bold', color: !alternateCategories ? '#fff' : '#1976d2', fontSize: 14 }}>
                Sequenziale
              </Text>
              <Text style={{ color: !alternateCategories ? '#e3f2fd' : '#666', fontSize: 11, textAlign: 'center' }}>
                Una categoria alla volta
              </Text>
            </TouchableOpacity>
          </View>
        </View>

        <GeneralSettingsCard
          numTeams={numTeams}
          setNumTeams={setNumTeams}
          stoccate={stoccate}
          setStoccate={setStoccate}
        />

        {/* Card gestione squadre/atleti */}
        <TeamBuilderMixed
          teams={teams}
          setTeams={setTeams}
          categories={categories}
        />

        <View className="button-container">
          <TouchableOpacity
            style={{ ...styles.button, ...styles.btnSecondary }}
            className="common-button success"
            onPress={() => {
              console.log("Creazione nuova gara mista");
              // Imposta correttamente il tipo di competizione
              localStorage.setItem('competitionType', 'mixed');
              localStorage.setItem('teams', JSON.stringify(teams));
              localStorage.setItem('mixed_config', JSON.stringify({ numTeams, stoccate, categories, alternateCategories }));

              // Genera incontri
              const generatedMatches = generateMatchesWithSpecialCase();
              console.log("Matches da salvare (creazione):", generatedMatches);
              localStorage.setItem('matches', JSON.stringify(generatedMatches));
              navigate('/schedule');
            }}
          >
            <Text style={styles.btnText}>Crea gare</Text>
          </TouchableOpacity>
        </View>
        <View className="button-container">
          <TouchableOpacity
            style={{ ...styles.button, ...styles.btnPrimary }}
            className="common-button"
            onPress={() => {
              console.log("Aggiornamento gara mista");
              // Imposta correttamente il tipo di competizione
              localStorage.setItem('competitionType', 'mixed');
              localStorage.setItem('teams', JSON.stringify(teams));
              localStorage.setItem('mixed_config', JSON.stringify({ numTeams, stoccate, categories, alternateCategories }));

              // Carica i match esistenti
              const oldMatches = JSON.parse(localStorage.getItem('matches') || '[]');
              console.log("Matches esistenti:", oldMatches);

              // Usa la logica speciale per generare i nuovi match
              const newMatches = generateMatchesWithSpecialCase();
              console.log("Nuovi matches generati (aggiornamento):", newMatches);

              // Merge dei match
              const mergedMatches = mergeMixedMatches(oldMatches, newMatches);
              console.log("Matches dopo merge:", mergedMatches);

              localStorage.setItem('matches', JSON.stringify(mergedMatches));
              navigate('/schedule');
            }}
          >
            <Text style={styles.btnText}>Aggiorna</Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  button: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 24,
    marginVertical: 8,
    fontWeight: 'bold',
    fontSize: 17,
    boxShadow: '0px 3px 4px rgba(25, 118, 210, 0.18)',
  },
  btnPrimary: {
    backgroundColor: '#1976d2',
    color: '#fff',
  },
  btnSecondary: {
    backgroundColor: '#388e3c',
    color: '#fff',
  },
  btnText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 17,
    textAlign: 'center',
  },
  pageTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 12,
    marginBottom: 8,
    gap: 8
  },
  pageTitleIcon: {
    fontSize: 36,
    color: '#1976d2',
    marginRight: 10,
  },
  pageTitleIconRight: {
    fontSize: 36,
    color: '#1976d2',
    marginLeft: 10,
  },
  pageTitleText: {
    fontSize: 32,
    fontWeight: 'bold',
    color: '#1976d2',
    letterSpacing: 0.5,
  },
  titleSpacer: {
    height: 6,
    backgroundColor: '#1976d2',
    borderRadius: 3,
    marginBottom: 18,
    width: 70,
    alignSelf: 'center',
  },
  container: {
    padding: 24,
    backgroundColor: '#f7fafd',
    flex: 1
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 18,
    boxShadow: '0 4px 24px #0002',
    padding: 16,
    marginVertical: 12,
    borderWidth: 2,
    borderColor: '#1976d2',
    transition: 'box-shadow 0.2s',
    maxWidth: '100vw',
    overflowX: 'auto',
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#1976d2',
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  input: {
    borderWidth: 2,
    borderColor: '#b3c6e6',
    borderRadius: 8,
    padding: 10,
    marginBottom: 8,
    backgroundColor: '#f4faff',
    fontWeight: 'bold',
    fontSize: 16,
    transition: 'border-color 0.2s',
  },
  addBtn: {
    backgroundColor: '#e3f2fd',
    borderRadius: 8,
    paddingVertical: 9,
    paddingHorizontal: 12,
    alignSelf: 'flex-start',
    marginTop: 6,
    marginBottom: 6
  },
  removeBtn: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 7,
    marginLeft: 4,
    borderWidth: 1,
    borderColor: '#eee',
  },
  info: {
    fontSize: 14,
    color: '#666',
    marginBottom: 10
  }
});

export default MixedCompetitionConfig;
